export const ClientLogo = () => (
  <svg width="110" height="16" viewBox="0 0 110 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M33.0428 11.1625L27.9123 2.09612H24.5264V14.6516H27.1389V6.56487L31.9686 14.6516H34.3061L38.9467 6.42737V14.6516H41.5162V2.09612H38.1732L33.0428 11.1625Z"
      fill="#F42434"
    />
    <path
      d="M82.4566 11.2485L73.8457 2.09612H70.1504V14.6516H72.9863V5.67971L81.4254 14.6516H85.2926V2.09612H82.4566V11.2485Z"
      fill="#F42434"
    />
    <path
      d="M8.63672 1.91572L0.859375 14.6517H4.17656L5.30234 12.5118H14.7297L15.993 14.6517H19.4305L11.5414 1.91572H8.63672ZM6.90078 9.84775L9.95156 4.81182L13.0969 9.84775H6.90078Z"
      fill="#F42434"
    />
    <path
      d="M101.251 1.91572H98.3467L90.5693 14.6517H93.8865L95.0123 12.5118H104.44L105.703 14.6517H109.14L101.251 1.91572ZM96.6107 9.84775L99.6701 4.81182L102.815 9.84775H96.6107Z"
      fill="#F42434"
    />
    <path
      d="M54.3896 1.9157L46.6123 14.6516H49.9295L51.0553 12.5118H60.474L61.7373 14.6516H65.1748L57.2857 1.9157H54.3896ZM52.6451 9.84773L55.6959 4.81179L58.8412 9.84773H52.6451Z"
      fill="#F42434"
    />
    <path
      d="M107.172 1.34845C106.158 1.34845 105.342 2.17345 105.342 3.18752V3.19611C105.342 4.20158 106.158 5.02658 107.164 5.02658C108.169 5.02658 108.994 4.20158 108.994 3.18752V3.17892C108.994 2.16486 108.178 1.34845 107.172 1.34845ZM107.164 4.61408C106.373 4.61408 105.754 3.98673 105.754 3.19611V3.18752C105.754 2.3883 106.373 1.75236 107.172 1.75236C107.971 1.75236 108.582 2.3797 108.582 3.17033V3.17892C108.582 3.98673 107.963 4.61408 107.164 4.61408Z"
      fill="#F42434"
    />
    <path
      d="M108.014 2.86095V2.85236C108.014 2.68048 107.962 2.55158 107.859 2.44845C107.739 2.31955 107.541 2.2508 107.258 2.2508H106.433V4.0297H106.922V3.4883H107.137L107.498 4.0297H108.065L107.644 3.41095C107.868 3.31642 108.014 3.13595 108.014 2.86095ZM107.524 2.89533C107.524 3.02423 107.429 3.10158 107.258 3.10158H106.931V2.67189H107.249C107.412 2.67189 107.524 2.74064 107.524 2.88673V2.89533Z"
      fill="#F42434"
    />
  </svg>
);
